<template>
  <div class="lang-select d-flex position-relative">
    <img src="@/assets/icons/lang-select.svg" class="img-fluid">
    <div class="current-locale text-secondary text-uppercase">{{$i18n.locale}}</div>
    <language-switcher v-slot="{ links }" tag="ul" active-class="active">
      <li :class="link.activeClass" v-for="link in links" :key="link.langIndex">
        <a :href="link.url">{{ link.langIndex }}</a>
      </li>
    </language-switcher>
  </div>
</template>

<script>
export default {
  name: 'LangSelect',
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.lang-select {
  padding: 10px 15px;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  transition: background .2s ease-in-out;
  &:hover {
    background: $light-grey;
    ul {
      visibility: visible;
      opacity: 1;
    }
  }
  img {
    max-width: 27px;
  }
  .current-locale {
    margin-left: 5px;
  }
  ul {
    list-style: none;
    padding: 0;
    position: absolute;
    margin-top: 32px;
    width: 100%;
    text-align: center;
    left: 0;
    background: $light-grey;
    padding-bottom: 3px;
    border-radius: 0 0 5px 5px;
    margin-bottom: 0;
    visibility: hidden;
    opacity: 0;
    transition: all .2s ease-in-out;
    > li {
      padding: 4px 5px;
      cursor: pointer;
      text-transform: uppercase;
      a {
        color: $secondary;
        display: block;
      }
      &.active {
        display: none;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    font-size: 12px;
    img {
      max-width: 20px;
    }
    ul {
      margin-top: 27px;
    }
  }
}
</style>
